import { Group } from "three";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Model3d } from "oc-jaco3d/arrangement3d/Model3d";
import { MyModel } from "../arrangement/MyModel";

/**
 * @abstact
 */
export class MyModel3d extends Model3d {
  constructor(jaco: Jaco) {
    // @ts-ignore
    super(jaco);
  }

  loadObject3DByModel(model: MyModel, onLoadCallback: Function) {
    let group = new Group();
    APP.modelsHelper.getRenderPromise(model).then((model3d) => {
      group.add(model3d);
      onLoadCallback();
      STAGE.dirty();
    });
    return group;
  }

  loadObject3DByOptions(options: any) {
    throw new Error("not implemented");
  }

  getMeta(): any {
    return this.jaco.getMeta();
  }
}
